import { Link, useParams } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Logo } from "@/components/Layout";
import { Loading, StatusBadge, useLoad } from "@/components/common";
import { GroupTerms } from "@/components/GroupTerms";
import { useAuth } from "@/context/Auth";

export default function GroupTermsPage() {
  const { gid } = useParams();
  const { user } = useAuth();
  const { data, error } = useLoad(`/groups/${gid}/public-terms`);
  return (
    <div className="min-h-screen bg-sky-50/40">
      <header className="mx-auto flex max-w-5xl items-center justify-between px-5 py-5"><Logo />
        <Button asChild className="rounded-full bg-[#0369a1]"><Link to={user ? `/app/groups/${gid}` : `/apply?next=/app/groups/${gid}`} data-testid="terms-join">{user ? "Open group" : "Join Tiyeni to take part"}</Link></Button></header>
      <main className="mx-auto max-w-5xl space-y-6 px-5 pb-16">
        {!data ? <Loading error={error} /> : <>
          <div>
            <div className="overline mb-2">Village banking group · rules everyone agrees to</div>
            <h1 className="font-heading text-3xl font-bold text-brand sm:text-4xl" data-testid="terms-group-name">{data.name}</h1>
            {data.description && <p className="mt-2 text-stone-600">{data.description}</p>}
            <div className="mt-3 flex flex-wrap gap-2 text-sm"><StatusBadge status={data.status} /><span className="text-stone-600">{data.member_count} member(s)</span></div>
          </div>
          <GroupTerms rules={data.rules} />
          <p className="text-xs text-stone-500">{data.model_note}</p>
        </>}
      </main>
    </div>
  );
}
